function GitHubLogo() {
    return (
        <img src="/images/githubLogo.png" alt="GitHub Logo" />
    )
}

export default GitHubLogo;